export function generate(length) {
    return Array.from({ length }, (_, i) => i);
}
//# sourceMappingURL=generate.js.map